import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import { AU_MOBILE_EVENTS } from "../../../tracking/au.mobile-events";
import { FINANCE_FIRST_EXPERIMENT_AMPLITUDE_EVENTS } from "../../../tracking/amplitude-events";
import TrackImpression from "../../shared/track-impression";
import { trackMobileCustomEventsAU } from "../../../tracking";
import { useHistory } from "react-router-dom";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const BuyWithConfidenceCard = ({cardImage, cardTitle, onClick, showFinanceFirstExperimentCard, btnText, icon}) => {
    const history = useHistory();
    if (showFinanceFirstExperimentCard) {
        const handleClick = async() => {
            await yieldToMain();
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.FF_VOLUME_EXPERIMENT, {
                eventAction: "Finance_card_clicked",
                eventLabel: "Get_pre_approval_CDP_buy_with_confidence"
            });

            history.push("/financing/get-pre-approval");
        };
        return (
            <div styleName={"styles.outer styles.outer2"}>
                <TrackImpression event={{gaName: AU_MOBILE_EVENTS.FF_VOLUME_EXPERIMENT, data: {eventLabel: "Finance_CDP_buy_with_confidence", eventAction: "Card_viewed"}, amplitudeName: FINANCE_FIRST_EXPERIMENT_AMPLITUDE_EVENTS.CARD_VIEWED, properties: {"Card_viewed": "Finance_CDP_buy_with_confidence"}}}>
                    <LazyImage width="82" height="82" src={icon} alt={cardTitle} />
                    <p styleName={"styles.title styles.subtitle"} onClick={handleClick}>{cardTitle}</p>
                    {btnText && <Button text={btnText} onClick={handleClick} />}
                </TrackImpression>
            </div>
        );
    }
    return (
        <div styleName={"styles.outer"}>
            <LazyImage alt={cardTitle} src={cardImage}  width= "82px" height= "82px" styleName={"styles.buyWithConfidenceImage"}/>
            <p styleName={"styles.title"} onClick={onClick}>{cardTitle}</p>
        </div>
    );
};

BuyWithConfidenceCard.propTypes = {
    cardImage: PropTypes.string,
    btnText: PropTypes.string,
    icon: PropTypes.object,
    showFinanceFirstExperimentCard: PropTypes.bool,
    cardTitle: PropTypes.string,
    onClick: PropTypes.func
};

export default BuyWithConfidenceCard;
